import React, { Component } from 'react';
import './App.css';

const currentEpochTime = Date.now();
const eventEpochTime = 1531600200000;
const almostEventEpochTime = 1531584000000;
const tooLateEpochTime = 1531627199000
let isItTimeYet;

if (currentEpochTime > tooLateEpochTime) {
  isItTimeYet = 'TOO LATE';
}
else if (currentEpochTime >= eventEpochTime) {
  isItTimeYet = 'YES';
}
else if (currentEpochTime >= almostEventEpochTime) {
  isItTimeYet = 'ALMOST';
} 
else {
  isItTimeYet = 'NO';
}
class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="site-wrapper">
          <div className="site-wrapper-inner">
            <div className="cover-container">
              <div className="inner cover">
                <h1 className="cover-heading">{isItTimeYet}</h1>
                <p className="lead">Crab time is <strong>July 14th</strong> at <strong>4:30 PM</strong> (30 minutes after <a href="http://isitcidertimeyet.com">cider time</a>)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js